<template
    ><div class="more-from-creators-club-container">
        <div class="more-from-creators-club-container__title">
            More from Ylands team
        </div>
        <tutorial-and-tips-icon
            class="more-from-creators-club-container__tutorials-and-tips-icon"
        ></tutorial-and-tips-icon>
        <div class="more-from-creators-club-container__tutorials-and-tips">
            Tutorials and Tips
        </div>
        <div class="more-from-creators-club-container__view-all">
            <a
                href="https://www.youtube.com/watch?v=Grl_q2W0vfU&list=PLQMKNKSmK6lScHLQXBp7kcDKLWAFjTaa3"
                target="_blank"
            >
                <div style="margin: 7px auto auto 0">
                    View All
                    <view-all-arrow
                        style="fill: #ffffff; width: 11px; height: 11px;"
                    ></view-all-arrow>
                </div>
            </a>
        </div>
        <div class="video-row">
            <iframe
                v-for="video in videos"
                :key="video.id"
                :src="video.url"
                class="video-element"
                loading="lazy"
                width="300"
                height="180"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            ></iframe>
        </div>
    </div>
</template>

<script>
import TutorialAndTipsIcon from 'Svgs/tutorial_poly_icon.svg?inline';
import ViewAllArrow from 'Svgs/view_all_arrow.svg?inline';

export default {
    name: 'MoreFromCreatorsClub',
    components: {
        TutorialAndTipsIcon,
        ViewAllArrow,
    },
    data() {
        return {
            videos: [
                { url: 'https://www.youtube.com/embed/M2n33TLU_9o' },
                { url: 'https://www.youtube.com/embed/3ejxlxGopB8' },
                { url: 'https://www.youtube.com/embed/CUGDInI023o' },
                { url: 'https://www.youtube.com/embed/CwMeSPHoLqY' },
            ],
        };
    },
};
</script>

<style scoped lang="scss">
.more-from-creators-club-container {
    display: grid;
    grid-template-rows: 1fr 0.5fr 3fr;
    grid-template-columns: 1fr 1fr 1fr;
    &__title {
        grid-row: 1;
        grid-column: 1 / 4;
        justify-self: center;
        margin-top: 2rem;
        height: 102px;
        color: #ffffff;
        font-family: $politica-font;
        font-size: 34px;
        font-weight: 700;
        letter-spacing: 0.88px;
        line-height: 51px;
        text-align: center;
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            width: 290px;
        }
    }
    &__tutorials-and-tips-icon {
        grid-row: 2;
        grid-column: 1;
        justify-self: left;
        margin-left: 3rem;
        @media (min-width: $xs-up) and (max-width: $sm-up) {
            justify-self: left;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            display: none;
        }
    }
    &__tutorials-and-tips {
        grid-row: 2;
        grid-column: 1;
        justify-self: left;
        margin-left: 7rem;
        width: 415px;
        height: 44px;
        color: #ffffff;
        font-family: $istok-font;
        font-size: 36px;
        font-weight: 700;
        letter-spacing: 0.57px;
        line-height: 53px;

        @media (max-width: $xl-up) {
            width: auto;
            grid-column: 1 / 3;
        }
        @media (min-width: $xs-up) and (max-width: $sm-up) {
            justify-self: right;
            margin-left: 0;
            margin-top: 1rem;
            width: 189px;
            height: 49px;
            font-size: 20px;
            font-weight: 700;
            letter-spacing: 0.32px;
            line-height: 25px;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            grid-column: 1 / 3;
            margin: 1rem auto auto 1rem;
            justify-self: left;
            width: 139px;
            font-size: 20px;
            letter-spacing: 0.32px;
            line-height: 25px;
        }
    }
    &__view-all {
        grid-column: 3;
        grid-row: 2;
        justify-self: right;
        margin-right: 2rem;
        margin-top: 0.5rem;
        margin-left: 6rem;
        width: 87px;
        height: 33px;
        color: #ffffff;
        font-family: $palanquin-font;
        font-size: 18px;
        font-weight: 400;
        letter-spacing: 0.07px;
        text-decoration: underline;
        @media (max-width: $sm-up) {
            margin-right: 7rem;
            margin-left: 2rem;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            margin-right: 0;
        }
    }
    &__view-all:hover {
        color: rgba(255, 255, 255, 0.5);
        margin-top: 0.4rem;
    }
}
.video-row {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 2rem;
    grid-row: 3;
    grid-column: 1 / 4;
    margin: 2rem 2rem auto 3rem;
    justify-self: center;
    @media (max-width: $xl-up +1) {
        grid-template-columns: repeat(4, 18rem);
        width: 90%;
        position: static;
        bottom: 0;
        right: 0;
        overflow-x: auto;
        grid-gap: 0;
    }
    @media (min-width: $xs-up) and (max-width: $sm-up) {
        grid-template-columns: repeat(4, 18rem);
        justify-items: center;
    }
    @media (min-width: $xxs-up) and (max-width: $xs-up) {
        margin: 2rem auto 3rem auto;
        grid-template-columns: repeat(4, 22rem);
    }
}
a:visited {
    color: white;
}
a:link {
    color: white;
}
.video-element {
    width: 308px;
    height: 183px;
    @media (max-width: $xl-up) {
        width: 248px;
        height: 150px;
    }
    @media (min-width: $xxs-up) and (max-width: $xs-up) {
        width: 300px;
        height: 183px;
    }
}
</style>
